import {
    $, addFilter, addAction, INIT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    const $hangingList = $('.hanging-list');
    if (!$hangingList.length) {
        return;
    }

    addFilter('css-vars/register', (styles) => ({
        ...styles,
        'hanging-list-height': () => `${$hangingList.outerHeight(true)}px`,
    }));
});
